"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidators = exports.conditionalValidator = exports.validateDateOfBirth = exports.maxValueValidator = exports.minValueValidator = exports.mustBeNumberValidator = exports.requiredValidatorWithMessage = exports.requiredValidator = exports.optionalValidator = exports.composeValidators = void 0;
function composeValidators(handlers) {
    return function (value) { return handlers.reduce(function (error, validator) { return error || validator(value); }, undefined); };
}
exports.composeValidators = composeValidators;
var optionalValidator = function (value) { return undefined; };
exports.optionalValidator = optionalValidator;
var requiredValidator = function (value) { return (value ? undefined : 'Required'); };
exports.requiredValidator = requiredValidator;
var requiredValidatorWithMessage = function (message) { return function (value) { return (value ? undefined : message); }; };
exports.requiredValidatorWithMessage = requiredValidatorWithMessage;
var mustBeNumberValidator = function (value) { return (isNaN(value) ? 'Must be a number' : undefined); };
exports.mustBeNumberValidator = mustBeNumberValidator;
var minValueValidator = function (min) { return function (value) { return isNaN(value) || value >= min ? undefined : "Should be greater than " + min; }; };
exports.minValueValidator = minValueValidator;
var maxValueValidator = function (max) { return function (value) { return isNaN(value) || value <= max ? undefined : "Should be less than " + max; }; };
exports.maxValueValidator = maxValueValidator;
var validateDateOfBirth = function (value) {
    if (value && value.year && value.month && value.day) {
        var year = Number(value.year);
        var month = Number(value.month) - 1;
        var day = Number(value.day);
        var testDate = new Date(year, month, day);
        if (testDate < new Date() &&
            testDate.getFullYear() > 1900 &&
            testDate.getFullYear() === year &&
            testDate.getMonth() === month &&
            testDate.getDate() === day) {
            return undefined;
        }
    }
    return 'Please enter a date of birth';
};
exports.validateDateOfBirth = validateDateOfBirth;
var conditionalValidator = function (validation, conditional) { return function (value) { return conditional(value) ? validation(value) : undefined; }; };
exports.conditionalValidator = conditionalValidator;
var createValidators = function (options) {
    var validations = [];
    if (options) {
        if (options.required) {
            if (options.errorMessage) {
                validations.push((0, exports.requiredValidatorWithMessage)(options.errorMessage));
            }
            else {
                validations.push(exports.requiredValidator);
            }
        }
        if (options.isNumber) {
            validations.push(exports.mustBeNumberValidator);
        }
        if (options.min) {
            validations.push((0, exports.minValueValidator)(options.min));
        }
        if (options.max) {
            validations.push((0, exports.maxValueValidator)(options.max));
        }
        if (options.dob) {
            validations.push(exports.validateDateOfBirth);
        }
    }
    return composeValidators(validations);
};
exports.createValidators = createValidators;
//# sourceMappingURL=validations.js.map